
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=title,description,created_by' : ''
    // pagination
    const page = data.page ? data.page : 1
    // status
    const fieldQuery = data.field_query ? '&field_query=' + JSON.stringify(data.field_query) : ''
    return axios.get(process.env.API_ENDPOINT + '/expense?token=' + VueCookies.get('token') + '&date_from=' + data.date_from + '&date_to=' + data.date_to + '&page=' + page + search + limit + fieldQuery)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/expense?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/expense/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/expense/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/expense/' + id + '?token=' + VueCookies.get('token'))
  },
  availableApprovedExpenses (data) {
    return axios.get(process.env.API_ENDPOINT + '/expense/available-approved-expenses?token=' + VueCookies.get('token') + '&teacher_id=' + data.teacher_id)
  },
  getApproveExpenses (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=title,description,created_by,status' : ''
    // pagination
    const page = data.page ? data.page : 1
    // status
    const fieldQuery = data.field_query ? '&field_query=' + JSON.stringify(data.field_query) : ''
    return axios.get(process.env.API_ENDPOINT + '/expense/approve?token=' + VueCookies.get('token') + '&page=' + page + search + limit + fieldQuery)
  }
}



// WEBPACK FOOTER //
// ./src/store/api/expenses.js